<p-toast [key]="toastKey" position="top-right"></p-toast>
<alert [nom]="nomAlert"></alert>
<div class="table-parametrage">
	<p-table
			[value]="ligneParametrages"
			[loading]="loading"
			loadingIcon="app-spinner"
			sortField="code"
			[rowHover]="true"
			[scrollable]="true"
			scrollHeight="560px">
		<ng-template pTemplate="header">
			<tr>
				<th scope="col" *ngFor="let col of colonnes" [pSortableColumn]="col.key"
					class="text-center" [style.width]="col.largeur ?? tailleColonneStandard">
					{{ col.header }}
					<p-sortIcon [field]="col.key"></p-sortIcon>
				</th>
			</tr>
			<tr>
				<th scope="col" *ngFor="let col of colonnes">
					<p-columnFilter type="text" [field]="col.key" matchMode="contains" [showMatchModes]="false" [showMenu]="false">
						<ng-template pTemplate="filter" let-filter="filterCallback" let-value="$implicit">
							<input type="text"
								   [value]="value"
								   pInputText
								   (input)="appliquerFiltre(filter, $event)"
								   class="input-filtre-parametrage">
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-parametrage>
			<tr [formGroup]="formParId.get(parametrage.id)">
				<td *ngFor="let col of colonnes" [ngClass]="{'ellipsis': col.ellipsis}">
					<input *ngIf="col.editable; else readonly" [formControlName]="col.key" pInputText type="text" class="input-parametrage">
					<ng-template #readonly>
						<span [title]="col.getValeur(parametrage)">{{ col.getValeur(parametrage) }}</span>
					</ng-template>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td [attr.colspan]="colonnes ? colonnes.length : 3" class="text-center">
					{{'SIGALE_ANGULAR.COMPONENTS.PARAMETRAGE.AUCUN_PARAMETRAGE' | translate}}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<footerBar *ngIf="!modeApplicationCohabitation; else footerBarModeCohabitation">
	<button (click)="enregistrer()"
			[disabled]="enregistrementInactif || loading"
			class="enregistrer-parametrage">
		{{'SIGALE_ANGULAR.COMPONENTS.PARAMETRAGE.ENREGISTRER' | translate}}
	</button>
</footerBar>

<ng-template #footerBarModeCohabitation>
	<div class="form-btn-section bottom-fixed">
		<div class="containerBT">
			<button (click)="enregistrer()"
					[disabled]="enregistrementInactif || loading"
					class="btn btn-primary">
				{{'SIGALE_ANGULAR.COMPONENTS.PARAMETRAGE.ENREGISTRER' | translate}}
			</button>
			<span *ngIf="loading" class="app-spinner m-2"></span>
		</div>
	</div>
</ng-template>
